export function cleanText(text: string) {
  if (!text) {
    return { cleanText: '', validateText: '' }
  }
  let validateText = text.replace(/[^a-zA-Z 0-9]+/g, '').trim()

  return { cleanText: text, validateText: validateText }
}
